
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import Icon from "@/components/UI/Icon.vue";
import NiceButton from "@/components/UI/NiceButton.vue";
@Component({
  components: {
    Icon,
    NiceButton
  }
})
export default class SingularityEmptyState extends Vue {
  @Prop() icon?: string;
  @Prop() title?: string;
  @Prop() description?: string;
  @Prop() buttonText?: string;
}
